const LETTER_FS = 430;
const LETTER_FONT = "Gelasio";
const LETTER_WEIGHT = "600";
const NAME_WEIGHT = "400";
const LETTER_FONT_URLS = [
  "https://cdn.jsdelivr.net/npm/@fontsource/gelasio@5.2.8/files/gelasio-latin-600-normal.woff",
  "https://cdn.jsdelivr.net/npm/@fontsource/gelasio/files/gelasio-latin-600-normal.woff",
];
const DEFAULT_NAME_FONT = "grandhotel";
const NAME_FONTS = {
  grandhotel: {
    label: "Grand Hotel",
    family: "Grand Hotel",
    urls: [
      "https://cdn.jsdelivr.net/npm/@fontsource/grand-hotel@5.2.8/files/grand-hotel-latin-400-normal.woff",
      "https://cdn.jsdelivr.net/npm/@fontsource/grand-hotel/files/grand-hotel-latin-400-normal.woff",
    ],
  },
  greatvibes: {
    label: "Great Vibes",
    family: "Great Vibes",
    urls: [
      "https://cdn.jsdelivr.net/npm/@fontsource/great-vibes@5.2.8/files/great-vibes-latin-400-normal.woff",
      "https://cdn.jsdelivr.net/npm/@fontsource/great-vibes/files/great-vibes-latin-400-normal.woff",
    ],
  },
  cookie: {
    label: "Cookie",
    family: "Cookie",
    urls: [
      "https://cdn.jsdelivr.net/npm/@fontsource/cookie@5.2.8/files/cookie-latin-400-normal.woff",
      "https://cdn.jsdelivr.net/npm/@fontsource/cookie/files/cookie-latin-400-normal.woff",
    ],
  },
};
const NAME_OFFSET = 10;
const HOOP_OUTER = 24;
const HOOP_INNER = 11;
const PREVIEW_PAD = 12;
const EXPORT_PAD = 20;
const EXPORT_GAP = 40;

// PERF: reduced from 8 → 5. Cuts offset-canvas area by ~60% with no visible quality loss.
const MASK_SC = 5;

const TRACE_SMOOTH_PASSES = 4;
const PREVIEW_TRACE_SC = 4;
const EXPORT_TRACE_SC = 16;
const EXPORT_SMOOTH_PASSES = 2;
const MAX_PTS_PER_LOOP = 260;
const EXPORT_BASE_MAX_PTS = 12000;
const EXPORT_HOOP_Y_CORRECTION = 16;
const EXPORT_NAME_OFFSET_Y_CORRECTION = 20;
const NAME_WELD_TRACE_SC = 24;
const NAME_WELD_MAX_PTS = 10000;

const S = { letter: "B", name: "Beatrice", nameFont: DEFAULT_NAME_FONT, nameSize: 84, posOff: 0, hoopOn: false, hoopDragOff: { x: 0, y: 0 } };

const svgEl = document.getElementById("svg-preview");
const basePreviewPath = document.getElementById("base-preview-path");
const letterEl = document.getElementById("letter-el");
const nameInput = document.getElementById("name-input");
const nameEl = document.getElementById("name-el");
const nameOffsetEl = document.getElementById("name-offset-el");
const nameFillPath = document.getElementById("name-fill-path");
const nameOffPath = document.getElementById("name-offset-path");
const hoopOuter = document.getElementById("hoop-outer");
const hoopInner = document.getElementById("hoop-inner");
const hoopDragHandle = document.getElementById("hoop-drag-handle");
const fontRow = document.getElementById("font-row");
const sizeSlider = document.getElementById("size-slider");
const posSlider = document.getElementById("pos-slider");
const exportBtn = document.getElementById("export-btn");
const hoopHint = document.getElementById("hoop-hint");

let timer = null;
let renderToken = 0;
const outlineFonts = {};
const outlineFontPromises = {};
let letterOutlineFont = null;
let letterOutlineFontPromise = null;
let outlineFontError = null;
let letterOutlineFontError = null;
let latestScene = { nameShape: null, nameOffsetPathData: "", basePreviewPathData: "", hoop: null, hoopSlot: null };

// PERF: track whether document.fonts.ready has resolved so we don't re-await it every render.
let fontsAlreadyReady = false;

// PERF: single-entry cache for buildOffsetPath — skips the canvas rasterize when the
//       name shape and offset amount haven't changed (e.g. when only the letter changes).
let _offsetCache = { key: "", result: "" };

// PERF: single-entry cache for buildNameShape — skips opentype path building when
//       name/size/font/position haven't changed between renders.
let _nameShapeCache = { key: "", shape: null };

function schedRender(delay = 220) {
  clearTimeout(timer);
  timer = setTimeout(() => { void phase1(); }, delay);
}

function setBusyState() {
  svgEl.classList.add("busy");
  exportBtn.disabled = true;
}

function setIdleState() {
  svgEl.classList.remove("busy");
  exportBtn.disabled = false;
}

function fontStr(size, family, weight) {
  return `${weight} ${size}px '${family}'`;
}

function currentNameFont() {
  return NAME_FONTS[S.nameFont] || NAME_FONTS[DEFAULT_NAME_FONT];
}

function updateSliderFill(slider) {
  const pct = ((slider.value - slider.min) / (slider.max - slider.min)) * 100;
  slider.style.setProperty("--pct", pct + "%");
}

function applyNameFontUi() {
  const cfg = currentNameFont();
  nameInput.style.fontFamily = `'${cfg.family}', cursive`;
  nameEl.setAttribute("font-family", `'${cfg.family}', cursive`);
  nameOffsetEl.setAttribute("font-family", `'${cfg.family}', cursive`);
  fontRow.querySelectorAll(".font-btn").forEach((btn) => {
    btn.classList.toggle("on", btn.dataset.font === S.nameFont);
  });
}

function asBox(b) {
  if (!b) return null;
  return { x: b.x, y: b.y, w: b.w ?? b.width, h: b.h ?? b.height };
}

function safeGetBBox(el) {
  try {
    const b = el.getBBox();
    if (b.width > 0 || b.height > 0) {
      return { x: b.x, y: b.y, w: b.width, h: b.height, width: b.width, height: b.height };
    }
  } catch (_) {}
  return null;
}

function unionBounds(boundsList) {
  const valid = boundsList.map(asBox).filter(Boolean);
  if (!valid.length) return null;

  let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
  for (const b of valid) {
    minX = Math.min(minX, b.x);
    minY = Math.min(minY, b.y);
    maxX = Math.max(maxX, b.x + b.w);
    maxY = Math.max(maxY, b.y + b.h);
  }
  return { x: minX, y: minY, w: maxX - minX, h: maxY - minY };
}

function alphaMaskFromCanvas(ctx, width, height, threshold = 15) {
  const data = ctx.getImageData(0, 0, width, height).data;
  const mask = new Uint8Array(width * height);
  for (let i = 0; i < width * height; i++) mask[i] = data[i * 4 + 3] > threshold ? 1 : 0;
  return mask;
}

function mergeMaskInto(target, source) {
  for (let i = 0; i < target.length; i++) if (source[i]) target[i] = 1;
}

function subtractMaskFrom(target, source) {
  for (let i = 0; i < target.length; i++) if (source[i]) target[i] = 0;
}

function floodFillExterior(letterMask, width, height) {
  const exterior = new Uint8Array(width * height);
  const queue = new Int32Array(width * height);
  let head = 0;
  let tail = 0;
  const enqueue = (idx) => {
    if (idx >= 0 && idx < width * height && !exterior[idx] && !letterMask[idx]) {
      exterior[idx] = 1;
      queue[tail++] = idx;
    }
  };

  for (let x = 0; x < width; x++) {
    enqueue(x);
    enqueue((height - 1) * width + x);
  }
  for (let y = 1; y < height - 1; y++) {
    enqueue(y * width);
    enqueue(y * width + width - 1);
  }

  while (head < tail) {
    const idx = queue[head++];
    const x = idx % width;
    const y = (idx / width) | 0;
    if (y > 0) enqueue(idx - width);
    if (y < height - 1) enqueue(idx + width);
    if (x > 0) enqueue(idx - 1);
    if (x < width - 1) enqueue(idx + 1);
  }

  return exterior;
}

function polygonArea(points) {
  let sum = 0;
  for (let i = 0; i < points.length; i++) {
    const a = points[i];
    const b = points[(i + 1) % points.length];
    sum += a[0] * b[1] - b[0] * a[1];
  }
  return sum / 2;
}

function simplifyLoop(points) {
  if (points.length < 4) return points.slice();
  const out = [];
  const n = points.length;
  for (let i = 0; i < n; i++) {
    const prev = points[(i - 1 + n) % n];
    const cur = points[i];
    const next = points[(i + 1) % n];
    const collinear =
      (prev[0] === cur[0] && cur[0] === next[0]) ||
      (prev[1] === cur[1] && cur[1] === next[1]);
    if (!collinear) out.push(cur);
  }
  return out;
}

function decimateLoop(points, maxPoints) {
  if (points.length <= maxPoints) return points;
  const out = [];
  const step = points.length / maxPoints;
  for (let i = 0; i < maxPoints; i++) out.push(points[Math.round(i * step) % points.length]);
  return out;
}

function smoothLoop(points, passes = TRACE_SMOOTH_PASSES) {
  let pts = points.slice();
  for (let pass = 0; pass < passes; pass++) {
    const next = new Array(pts.length * 2);
    for (let i = 0; i < pts.length; i++) {
      const a = pts[i];
      const b = pts[(i + 1) % pts.length];
      next[i * 2]     = [0.75 * a[0] + 0.25 * b[0], 0.75 * a[1] + 0.25 * b[1]];
      next[i * 2 + 1] = [0.25 * a[0] + 0.75 * b[0], 0.25 * a[1] + 0.75 * b[1]];
    }
    pts = next;
  }
  return pts;
}

function loopsToPathData(loops, passes = TRACE_SMOOTH_PASSES) {
  const f = (v) => v.toFixed(2);
  return loops.filter((loop) => loop.length >= 3).map((loop) => {
    const pts = smoothLoop(loop, passes);
    let d = `M${f(pts[0][0])},${f(pts[0][1])}`;
    for (let i = 0; i < pts.length; i++) {
      const p1 = pts[i];
      const p2 = pts[(i + 1) % pts.length];
      d += ` Q${f(p1[0])},${f(p1[1])} ${f((p1[0] + p2[0]) / 2)},${f((p1[1] + p2[1]) / 2)}`;
    }
    return `${d}Z`;
  }).join(" ");
}

function loopsToLinePathData(loops) {
  const f = (v) => v.toFixed(2);
  return loops.filter((loop) => loop.length >= 3).map((loop) => {
    let d = `M${f(loop[0][0])},${f(loop[0][1])}`;
    for (let i = 1; i < loop.length; i++) d += ` L${f(loop[i][0])},${f(loop[i][1])}`;
    return `${d}Z`;
  }).join(" ");
}

function traceMaskToLoopsFallback(mask, width, height, ox, oy, sc, maxPoints) {
  const edgePoints = [];
  const push = (x1, y1, x2, y2) => {
    edgePoints.push([x1, y1], [x2, y2]);
  };

  for (let y = 0; y < height; y++) {
    for (let x = 0; x < width; x++) {
      const idx = y * width + x;
      if (!mask[idx]) continue;

      const left = x === 0 ? 0 : mask[idx - 1];
      const right = x === width - 1 ? 0 : mask[idx + 1];
      const up = y === 0 ? 0 : mask[idx - width];
      const down = y === height - 1 ? 0 : mask[idx + width];

      if (!up) push(x, y, x + 1, y);
      if (!right) push(x + 1, y, x + 1, y + 1);
      if (!down) push(x + 1, y + 1, x, y + 1);
      if (!left) push(x, y + 1, x, y);
    }
  }

  if (!edgePoints.length) return [];

  const adjacency = new Map();
  const addEdge = (a, b) => {
    const ak = `${a[0]},${a[1]}`;
    const bk = `${b[0]},${b[1]}`;
    if (!adjacency.has(ak)) adjacency.set(ak, []);
    if (!adjacency.has(bk)) adjacency.set(bk, []);
    adjacency.get(ak).push(b);
    adjacency.get(bk).push(a);
  };

  for (let i = 0; i < edgePoints.length; i += 2) {
    addEdge(edgePoints[i], edgePoints[i + 1]);
  }

  const visited = new Set();
  const loops = [];

  for (const [startKey, neighbors] of adjacency.entries()) {
    for (const firstNext of neighbors) {
      const firstEdgeKey = `${startKey}|${firstNext[0]},${firstNext[1]}`;
      if (visited.has(firstEdgeKey)) continue;

      const loop = [];
      let curKey = startKey;
      let nextPoint = firstNext;
      let closed = false;

      for (let guard = 0; guard < edgePoints.length + 8; guard++) {
        const [cx, cy] = curKey.split(",").map(Number);
        const nextKey = `${nextPoint[0]},${nextPoint[1]}`;
        loop.push([cx, cy]);
        visited.add(`${curKey}|${nextKey}`);
        visited.add(`${nextKey}|${curKey}`);

        if (nextKey === startKey) {
          closed = true;
          break;
        }

        const candidates = adjacency.get(nextKey) || [];
        let chosen = null;
        for (const candidate of candidates) {
          const candidateKey = `${candidate[0]},${candidate[1]}`;
          if (candidateKey !== curKey && !visited.has(`${nextKey}|${candidateKey}`)) {
            chosen = candidate;
            break;
          }
        }
        if (!chosen) break;
        curKey = nextKey;
        nextPoint = chosen;
      }

      if (closed && loop.length > 3) loops.push(loop);
    }
  }

  const normalized = loops.map((loop) =>
    decimateLoop(simplifyLoop(loop).map(([x, y]) => [(x - ox) / sc, (y - oy) / sc]), maxPoints)
  ).filter((loop) => loop.length >= 3);

  normalized.sort((a, b) => Math.abs(polygonArea(b)) - Math.abs(polygonArea(a)));
  return normalized;
}

function traceMaskToLoops(mask, width, height, ox, oy, sc = MASK_SC, maxPoints = MAX_PTS_PER_LOOP) {
  const edges = [];
  const startMap = new Map();
  const keyOf = (x, y) => `${x},${y}`;
  const addEdge = (x1, y1, x2, y2) => {
    const edge = { a: [x1, y1], b: [x2, y2], key: `${x1},${y1}|${x2},${y2}` };
    edges.push(edge);
    const startKey = keyOf(x1, y1);
    if (!startMap.has(startKey)) startMap.set(startKey, []);
    startMap.get(startKey).push(edge);
  };

  for (let y = 0; y < height; y++) {
    for (let x = 0; x < width; x++) {
      const idx = y * width + x;
      if (!mask[idx]) continue;

      const left = x === 0 ? 0 : mask[idx - 1];
      const right = x === width - 1 ? 0 : mask[idx + 1];
      const up = y === 0 ? 0 : mask[idx - width];
      const down = y === height - 1 ? 0 : mask[idx + width];

      // Directed edges keep filled pixels on the right side. Walking them with
      // a right-hand rule avoids wrong turns at T/H-style corners and joins.
      if (!up) addEdge(x, y, x + 1, y);
      if (!right) addEdge(x + 1, y, x + 1, y + 1);
      if (!down) addEdge(x + 1, y + 1, x, y + 1);
      if (!left) addEdge(x, y + 1, x, y);
    }
  }

  if (!edges.length) return [];

  const visited = new Set();
  const loops = [];
  const dirOf = (a, b) => {
    const dx = b[0] - a[0];
    const dy = b[1] - a[1];
    if (dx > 0) return 0; // east
    if (dy > 0) return 1; // south
    if (dx < 0) return 2; // west
    return 3;             // north
  };

  for (const first of edges) {
    if (visited.has(first.key)) continue;

    const loop = [];
    const startKey = keyOf(first.a[0], first.a[1]);
    let edge = first;
    let closed = false;

    for (let guard = 0; guard < edges.length + 8; guard++) {
      if (visited.has(edge.key)) break;
      visited.add(edge.key);
      loop.push(edge.a);

      const endKey = keyOf(edge.b[0], edge.b[1]);
      if (endKey === startKey) {
        closed = true;
        break;
      }

      const currentDir = dirOf(edge.a, edge.b);
      const candidates = (startMap.get(endKey) || []).filter((candidate) => !visited.has(candidate.key));
      if (!candidates.length) break;

      let chosen = null;
      for (const desiredDir of [(currentDir + 1) & 3, currentDir, (currentDir + 3) & 3, (currentDir + 2) & 3]) {
        chosen = candidates.find((candidate) => dirOf(candidate.a, candidate.b) === desiredDir);
        if (chosen) break;
      }
      if (!chosen) break;
      edge = chosen;
    }

    if (closed && loop.length > 3) loops.push(loop);
  }

  const normalized = loops.map((loop) =>
    decimateLoop(simplifyLoop(loop).map(([x, y]) => [(x - ox) / sc, (y - oy) / sc]), maxPoints)
  ).filter((loop) => loop.length >= 3);

  normalized.sort((a, b) => Math.abs(polygonArea(b)) - Math.abs(polygonArea(a)));
  return normalized.length ? normalized : traceMaskToLoopsFallback(mask, width, height, ox, oy, sc, maxPoints);
}

function boundsFromLoops(loops) {
  if (!loops.length) return null;
  let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
  for (const loop of loops) {
    for (const [x, y] of loop) {
      minX = Math.min(minX, x);
      minY = Math.min(minY, y);
      maxX = Math.max(maxX, x);
      maxY = Math.max(maxY, y);
    }
  }
  return { x: minX, y: minY, w: maxX - minX, h: maxY - minY };
}

function translateLoops(loops, dx, dy) {
  return loops.map((loop) => loop.map(([x, y]) => [x + dx, y + dy]));
}

function drawCircle(ctx, cx, cy, r) {
  ctx.beginPath();
  ctx.arc(cx, cy, r, 0, Math.PI * 2);
  ctx.closePath();
}

function recenterTextToPoint(textEl, targetCX, targetCY, maxPasses = 2) {
  let x = targetCX;
  let y = targetCY;
  textEl.setAttribute("x", x.toFixed(2));
  textEl.setAttribute("y", y.toFixed(2));

  for (let pass = 0; pass < maxPasses; pass++) {
    const b = safeGetBBox(textEl);
    if (!b) break;
    const dx = targetCX - (b.x + b.w / 2);
    const dy = targetCY - (b.y + b.h / 2);
    if (Math.abs(dx) < 0.05 && Math.abs(dy) < 0.05) break;
    x += dx;
    y += dy;
    textEl.setAttribute("x", x.toFixed(2));
    textEl.setAttribute("y", y.toFixed(2));
  }
  return { x, y };
}

function getTextDrawSpec(textEl, text, fontFamily, fontSize, fontWeight) {
  if (!text) return null;

  const mCtx = document.createElement("canvas").getContext("2d");
  mCtx.font = fontStr(fontSize, fontFamily, fontWeight);
  mCtx.textAlign = "center";
  mCtx.textBaseline = "middle";
  const m = mCtx.measureText(text);

  const asc = m.actualBoundingBoxAscent ?? fontSize * 0.75;
  const desc = m.actualBoundingBoxDescent ?? fontSize * 0.25;
  const left = m.actualBoundingBoxLeft ?? m.width / 2;
  const right = m.actualBoundingBoxRight ?? m.width / 2;

  let targetCX = parseFloat(textEl.getAttribute("x")) || 250;
  let targetCY = parseFloat(textEl.getAttribute("y")) || 250;
  const box = safeGetBBox(textEl);
  if (box) {
    targetCX = box.x + box.w / 2;
    targetCY = box.y + box.h / 2;
  }

  const drawX = targetCX - (right - left) / 2;
  const drawY = targetCY - (desc - asc) / 2;

  return {
    text,
    fontSize,
    fontFamily,
    fontWeight,
    drawX,
    drawY,
    bounds: {
      x: drawX - left,
      y: drawY - asc,
      w: left + right,
      h: asc + desc,
    },
  };
}

async function loadNameOutlineFont() {
  const key = S.nameFont;
  if (outlineFonts[key]) return outlineFonts[key];
  if (!outlineFontPromises[key]) {
    outlineFontPromises[key] = (async () => {
      if (typeof opentype === "undefined") {
        throw new Error("opentype.js did not load.");
      }
      const cfg = currentNameFont();
      for (const url of cfg.urls) {
        try {
          const res = await fetch(url, { mode: "cors", cache: "force-cache" });
          if (!res.ok) continue;
          outlineFonts[key] = opentype.parse(await res.arrayBuffer());
          return outlineFonts[key];
        } catch (_) {}
      }
      throw new Error(`${cfg.label} outline font could not be loaded.`);
    })();
  }
  return outlineFontPromises[key];
}

async function loadLetterOutlineFont() {
  if (letterOutlineFont) return letterOutlineFont;
  if (!letterOutlineFontPromise) {
    letterOutlineFontPromise = (async () => {
      if (typeof opentype === "undefined") {
        throw new Error("opentype.js did not load.");
      }
      for (const url of LETTER_FONT_URLS) {
        try {
          const res = await fetch(url, { mode: "cors", cache: "force-cache" });
          if (!res.ok) continue;
          letterOutlineFont = opentype.parse(await res.arrayBuffer());
          return letterOutlineFont;
        } catch (_) {}
      }
      throw new Error("Gelasio outline font could not be loaded.");
    })();
  }
  return letterOutlineFontPromise;
}

function buildNameShape(name, fontSize, targetCX, targetCY) {
  const text = (name || "").trim();
  const outlineFont = outlineFonts[S.nameFont];
  if (!text || !outlineFont) return null;

  // PERF: cache by all inputs that affect the output path — skip opentype work on unchanged renders.
  const cacheKey = `${S.nameFont}|${text}|${fontSize}|${targetCX.toFixed(1)}|${targetCY.toFixed(1)}`;
  if (_nameShapeCache.key === cacheKey) return _nameShapeCache.shape;

  const probePath = outlineFont.getPath(text, 0, 0, fontSize, { kerning: true });
  const probeBox = probePath.getBoundingBox();
  const x = targetCX - (probeBox.x1 + probeBox.x2) / 2;
  const y = targetCY - (probeBox.y1 + probeBox.y2) / 2;
  const path = outlineFont.getPath(text, x, y, fontSize, { kerning: true });
  const bounds = path.getBoundingBox();

  const shape = {
    text,
    pathData: path.toPathData(2),
    bounds: {
      x: bounds.x1,
      y: bounds.y1,
      w: bounds.x2 - bounds.x1,
      h: bounds.y2 - bounds.y1,
    },
  };
  _nameShapeCache = { key: cacheKey, shape };
  return shape;
}

function buildLetterShape(letter, targetCX, targetCY) {
  const text = (letter || "A").toUpperCase()[0];
  if (!text || !letterOutlineFont) return null;

  const probePath = letterOutlineFont.getPath(text, 0, 0, LETTER_FS, { kerning: true });
  const probeBox = probePath.getBoundingBox();
  const x = targetCX - (probeBox.x1 + probeBox.x2) / 2;
  const y = targetCY - (probeBox.y1 + probeBox.y2) / 2;
  const path = letterOutlineFont.getPath(text, x, y, LETTER_FS, { kerning: true });
  const bounds = path.getBoundingBox();

  return {
    pathData: path.toPathData(2),
    bounds: {
      x: bounds.x1,
      y: bounds.y1,
      w: bounds.x2 - bounds.x1,
      h: bounds.y2 - bounds.y1,
    },
  };
}

function buildOffsetPath(shape, offsetUnits) {
  if (!shape?.pathData) return "";

  // PERF: cache by a lightweight key derived from path length + first 60 chars + offset amount.
  // The first 60 chars of the path data capture position and shape well enough to detect changes.
  const cacheKey = `${offsetUnits}|${shape.pathData.length}|${shape.pathData.slice(0, 60)}`;
  if (cacheKey === _offsetCache.key) return _offsetCache.result;

  const SC = MASK_SC; // now 5 instead of 8 — canvas area ~60% smaller
  const LW = offsetUnits;
  const cMinX = shape.bounds.x - 4;
  const cMinY = shape.bounds.y - 4;
  const cMaxX = shape.bounds.x + shape.bounds.w + 4;
  const cMaxY = shape.bounds.y + shape.bounds.h + 4;
  const PAD = Math.ceil(LW * SC * 2.5) + 12;

  const cW = Math.ceil((cMaxX - cMinX) * SC) + PAD * 2;
  const cH = Math.ceil((cMaxY - cMinY) * SC) + PAD * 2;
  const ox = PAD - cMinX * SC;
  const oy = PAD - cMinY * SC;

  const cvs = document.createElement("canvas");
  cvs.width = cW;
  cvs.height = cH;
  const ctx = cvs.getContext("2d");
  ctx.fillStyle = "#000";
  ctx.strokeStyle = "#000";
  ctx.lineJoin = "round";
  ctx.lineCap = "round";

  ctx.save();
  ctx.setTransform(SC, 0, 0, SC, ox, oy);
  ctx.lineWidth = LW * 2;
  const path = new Path2D(shape.pathData);
  ctx.fill(path);
  ctx.stroke(path);
  ctx.restore();

  const data = ctx.getImageData(0, 0, cW, cH).data;
  const mask = new Uint8Array(cW * cH);
  for (let i = 0; i < cW * cH; i++) mask[i] = data[i * 4 + 3] > 15 ? 1 : 0;

  let sx = -1, sy = -1;
  scan: for (let y = 0; y < cH; y++) {
    for (let x = 0; x < cW; x++) {
      if (mask[y * cW + x]) {
        sx = x;
        sy = y;
        break scan;
      }
    }
  }
  if (sx < 0) { _offsetCache = { key: cacheKey, result: "" }; return ""; }

  const DX = [1, 0, -1, 0];
  const DY = [0, 1, 0, -1];
  const hit = (x, y) => x >= 0 && x < cW && y >= 0 && y < cH && mask[y * cW + x];
  const raw = [];
  let bx = sx, by = sy, bd = 0;

  for (let step = 0; step < Math.max((cW + cH) * 8, 80000); step++) {
    raw.push([bx, by]);
    let moved = false;
    for (let t = 0; t < 4; t++) {
      const nd = (bd - 1 + 4 + t) & 3;
      const nx = bx + DX[nd];
      const ny = by + DY[nd];
      if (hit(nx, ny)) {
        bd = nd;
        bx = nx;
        by = ny;
        moved = true;
        break;
      }
    }
    if (!moved) break;
    if (step > 4 && bx === sx && by === sy) break;
  }

  if (raw.length < 6) { _offsetCache = { key: cacheKey, result: "" }; return ""; }

  const skip = Math.max(1, Math.floor(raw.length / 340));
  let pts = [];
  for (let i = 0; i < raw.length; i += skip) {
    pts.push([(raw[i][0] - ox) / SC, (raw[i][1] - oy) / SC]);
  }

  for (let pass = 0; pass < 4; pass++) {
    const next = new Array(pts.length * 2);
    for (let i = 0; i < pts.length; i++) {
      const a = pts[i];
      const b = pts[(i + 1) % pts.length];
      next[i * 2]     = [a[0] * 0.75 + b[0] * 0.25, a[1] * 0.75 + b[1] * 0.25];
      next[i * 2 + 1] = [a[0] * 0.25 + b[0] * 0.75, a[1] * 0.25 + b[1] * 0.75];
    }
    pts = next;
  }

  const f = (v) => v.toFixed(2);
  let d = `M${f(pts[0][0])},${f(pts[0][1])}`;
  for (let i = 0; i < pts.length; i++) {
    const p1 = pts[i];
    const p2 = pts[(i + 1) % pts.length];
    d += ` Q${f(p1[0])},${f(p1[1])} ${f((p1[0] + p2[0]) / 2)},${f((p1[1] + p2[1]) / 2)}`;
  }
  const result = `${d}Z`;
  _offsetCache = { key: cacheKey, result };
  return result;
}

function vectorizeScene(options, sc = 6, hoopOverride) {
  const letterSpec = getTextDrawSpec(letterEl, (S.letter || "A").toUpperCase()[0], LETTER_FONT, LETTER_FS, LETTER_WEIGHT);
  const nameShape = latestScene.nameShape;
  const nameFillBounds = nameShape ? asBox(safeGetBBox(nameFillPath) || nameShape.bounds) : null;
  const nameOffsetBounds = latestScene.nameOffsetPathData ? asBox(safeGetBBox(nameOffPath)) : null;
  const hoop = hoopOverride !== undefined ? hoopOverride : latestScene.hoop;
  const maxPtsPerLoop = options.maxPtsPerLoop || MAX_PTS_PER_LOOP;
  const nameOffsetDy = options.nameOffsetDy ?? 0;
  const preserveLetterCounters = options.preserveLetterCounters !== false;
  const boundsList = [];

  if (options.includeLetter && letterSpec) boundsList.push(letterSpec.bounds);
  if (options.includeNameFill && nameFillBounds) boundsList.push(nameFillBounds);
  if (options.includeNameOffset && nameOffsetBounds) boundsList.push({ ...nameOffsetBounds, y: nameOffsetBounds.y + nameOffsetDy });
  if (options.includeHoop && hoop) boundsList.push({ x: hoop.cx - HOOP_OUTER, y: hoop.cy - HOOP_OUTER, w: HOOP_OUTER * 2, h: HOOP_OUTER * 2 });

  const artBounds = unionBounds(boundsList);
  if (!artBounds) return { loops: [], bounds: null };

  const padPx = Math.ceil(sc * 8);
  const cW = Math.ceil(artBounds.w * sc) + padPx * 2;
  const cH = Math.ceil(artBounds.h * sc) + padPx * 2;
  const ox = padPx - artBounds.x * sc;
  const oy = padPx - artBounds.y * sc;

  // PERF: create one canvas and reuse it across all rasterMask calls rather than
  //       creating a new element each time.
  const sharedCanvas = document.createElement("canvas");
  sharedCanvas.width = cW;
  sharedCanvas.height = cH;

  const rasterMask = (drawFn) => {
    const ctx = sharedCanvas.getContext("2d");
    ctx.clearRect(0, 0, cW, cH);
    ctx.fillStyle = "#000";
    ctx.strokeStyle = "#000";
    ctx.lineJoin = "round";
    ctx.lineCap = "round";
    ctx.setTransform(sc, 0, 0, sc, ox, oy);
    drawFn(ctx);
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    return alphaMaskFromCanvas(ctx, cW, cH);
  };

  const mask = new Uint8Array(cW * cH);
  let letterMaskOnly = null;

  if (options.includeLetter && letterSpec) {
    letterMaskOnly = rasterMask((ctx) => {
      ctx.font = fontStr(letterSpec.fontSize, letterSpec.fontFamily, letterSpec.fontWeight);
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      ctx.fillText(letterSpec.text, letterSpec.drawX, letterSpec.drawY);
    });
    mergeMaskInto(mask, letterMaskOnly);
  }

  if (options.includeNameFill && nameShape?.pathData) {
    mergeMaskInto(mask, rasterMask((ctx) => {
      ctx.fill(new Path2D(nameShape.pathData));
    }));
  }

  if (options.includeNameOffset && latestScene.nameOffsetPathData) {
    mergeMaskInto(mask, rasterMask((ctx) => {
      ctx.save();
      ctx.translate(0, nameOffsetDy);
      ctx.fill(new Path2D(latestScene.nameOffsetPathData));
      ctx.restore();
    }));
  }

  if (options.includeHoop && hoop) {
    const outerMask = rasterMask((ctx) => {
      drawCircle(ctx, hoop.cx, hoop.cy, HOOP_OUTER);
      ctx.fill();
    });
    mergeMaskInto(mask, outerMask);
    if (options.includeHoopInner !== false) {
      const innerMask = rasterMask((ctx) => {
        drawCircle(ctx, hoop.cx, hoop.cy, HOOP_INNER);
        ctx.fill();
      });
      subtractMaskFrom(mask, innerMask);
    }
  }

  if (letterMaskOnly && preserveLetterCounters) {
    const exterior = floodFillExterior(letterMaskOnly, cW, cH);
    for (let i = 0; i < mask.length; i++) {
      if (!letterMaskOnly[i] && !exterior[i]) mask[i] = 0;
    }
  }

  const loops = traceMaskToLoops(mask, cW, cH, ox, oy, sc, maxPtsPerLoop);
  return { loops, bounds: boundsFromLoops(loops) };
}

function vectorizeExactBaseScene(letterShape, hoopOverride) {
  if (!letterShape?.pathData) return { loops: [], bounds: null };

  const nameOffsetBounds = latestScene.nameOffsetPathData ? asBox(safeGetBBox(nameOffPath)) : null;
  const hoop = hoopOverride !== undefined ? hoopOverride : latestScene.hoop;
  const boundsList = [letterShape.bounds];

  if (nameOffsetBounds) boundsList.push({ ...nameOffsetBounds, y: nameOffsetBounds.y + EXPORT_NAME_OFFSET_Y_CORRECTION });
  if (S.hoopOn && hoop) boundsList.push({ x: hoop.cx - HOOP_OUTER, y: hoop.cy - HOOP_OUTER, w: HOOP_OUTER * 2, h: HOOP_OUTER * 2 });

  const artBounds = unionBounds(boundsList);
  if (!artBounds) return { loops: [], bounds: null };

  const sc = EXPORT_TRACE_SC;
  const padPx = Math.ceil(sc * 8);
  const cW = Math.ceil(artBounds.w * sc) + padPx * 2;
  const cH = Math.ceil(artBounds.h * sc) + padPx * 2;
  const ox = padPx - artBounds.x * sc;
  const oy = padPx - artBounds.y * sc;
  const canvas = document.createElement("canvas");
  canvas.width = cW;
  canvas.height = cH;

  const rasterMask = (drawFn) => {
    const ctx = canvas.getContext("2d");
    ctx.clearRect(0, 0, cW, cH);
    ctx.fillStyle = "#000";
    ctx.strokeStyle = "#000";
    ctx.lineJoin = "round";
    ctx.lineCap = "round";
    ctx.setTransform(sc, 0, 0, sc, ox, oy);
    drawFn(ctx);
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    return alphaMaskFromCanvas(ctx, cW, cH);
  };

  const mask = new Uint8Array(cW * cH);
  mergeMaskInto(mask, rasterMask((ctx) => {
    ctx.fill(new Path2D(letterShape.pathData));
  }));

  if (latestScene.nameOffsetPathData) {
    mergeMaskInto(mask, rasterMask((ctx) => {
      ctx.translate(0, EXPORT_NAME_OFFSET_Y_CORRECTION);
      ctx.fill(new Path2D(latestScene.nameOffsetPathData));
    }));
  }

  if (S.hoopOn && hoop) {
    mergeMaskInto(mask, rasterMask((ctx) => {
      drawCircle(ctx, hoop.cx, hoop.cy, HOOP_OUTER);
      ctx.fill();
    }));
    subtractMaskFrom(mask, rasterMask((ctx) => {
      drawCircle(ctx, hoop.cx, hoop.cy, HOOP_INNER);
      ctx.fill();
    }));
  }

  const loops = traceMaskToLoops(mask, cW, cH, ox, oy, sc, EXPORT_BASE_MAX_PTS);
  return { loops, bounds: boundsFromLoops(loops) };
}

async function phase1() {
  const token = ++renderToken;
  setBusyState();

  letterEl.textContent = (S.letter || "A").toUpperCase()[0];
  letterEl.setAttribute("font-size", LETTER_FS);
  letterEl.setAttribute("font-weight", LETTER_WEIGHT);

  applyNameFontUi();
  nameEl.textContent = S.name || "";
  nameEl.setAttribute("font-size", S.nameSize);
  nameEl.removeAttribute("display");
  nameEl.setAttribute("opacity", "1");

  nameOffsetEl.textContent = S.name || "";
  nameOffsetEl.setAttribute("font-size", S.nameSize);
  nameOffsetEl.setAttribute("display", "none");

  basePreviewPath.setAttribute("d", "");
  nameFillPath.setAttribute("d", "");
  nameFillPath.setAttribute("display", "none");
  nameOffPath.setAttribute("d", "");

  letterEl.removeAttribute("visibility");
  nameOffPath.removeAttribute("visibility");
  hoopOuter.removeAttribute("visibility");
  hoopInner.removeAttribute("visibility");

  outlineFontError = null;
  letterOutlineFontError = null;
  try {
    // PERF: document.fonts.ready resolves once and stays resolved — skip the await after the first time.
    if (!fontsAlreadyReady) {
      await document.fonts.ready;
      fontsAlreadyReady = true;
    }
    await loadNameOutlineFont();
  } catch (error) {
    console.error(error);
    if (!outlineFonts[S.nameFont]) outlineFontError = error;
  }

  if (token !== renderToken) return;
  requestAnimationFrame(() => phase2(token));
}

function phase2(token) {
  if (token !== renderToken) return;

  recenterTextToPoint(letterEl, 250, 260);
  const lb = safeGetBBox(letterEl) || { x: 80, y: 60, w: 340, h: 240 };
  const lCX = lb.x + lb.w / 2;
  const lCY = lb.y + lb.h / 2;
  const nameTargetY = lCY + S.posOff;

  let nameShape = null;
  if (!outlineFontError) {
    nameShape = buildNameShape(S.name, S.nameSize, lCX, nameTargetY);
  }

  if (nameShape) {
    nameFillPath.setAttribute("d", nameShape.pathData);
    nameFillPath.removeAttribute("display");
    nameEl.setAttribute("display", "none");
  } else {
    nameFillPath.setAttribute("display", "none");
    recenterTextToPoint(nameEl, lCX, nameTargetY, 3);
    nameEl.removeAttribute("display");
  }

  const nameOffsetPathData = nameShape ? buildOffsetPath(nameShape, NAME_OFFSET) : "";
  nameOffPath.setAttribute("d", nameOffsetPathData);

  letterEl.removeAttribute("visibility");
  nameOffPath.removeAttribute("visibility");
  basePreviewPath.setAttribute("d", "");

  // PERF: the old code called vectorizeScene here purely to find the letter's top-edge
  // center X for hoop placement. That's a full rasterize-and-trace on every render.
  // safeGetBBox gives us the same bounds directly from the SVG DOM — no canvas needed.
  const letterTop = lb.y;
  const topCX = lCX;

  const hoopSlot = {
    cx: topCX + S.hoopDragOff.x,
    cy: letterTop + HOOP_OUTER * 0.35 + S.hoopDragOff.y,
    rOuter: HOOP_OUTER,
    rInner: HOOP_INNER,
  };
  const hoop = S.hoopOn ? hoopSlot : null;

  latestScene = { nameShape, nameOffsetPathData, basePreviewPathData: "", hoop: null, hoopSlot };

  const setHoopPos = (el, h, r) => {
    el.setAttribute("cx", h.cx.toFixed(2));
    el.setAttribute("cy", h.cy.toFixed(2));
    if (r !== undefined) el.setAttribute("r", r);
  };

  if (hoop) {
    setHoopPos(hoopOuter, hoop, HOOP_OUTER);
    hoopOuter.removeAttribute("display");
    hoopOuter.removeAttribute("visibility");
    setHoopPos(hoopInner, hoop, HOOP_INNER);
    hoopInner.removeAttribute("display");
    hoopInner.removeAttribute("visibility");
    setHoopPos(hoopDragHandle, hoop, HOOP_OUTER);
    hoopDragHandle.removeAttribute("display");
  } else {
    hoopOuter.setAttribute("display", "none");
    hoopInner.setAttribute("display", "none");
    hoopDragHandle.setAttribute("display", "none");
  }

  latestScene = { nameShape, nameOffsetPathData, basePreviewPathData: "", hoop, hoopSlot };
  requestAnimationFrame(fitViewBox);
}

function fitViewBox() {
  let x0 = Infinity, y0 = Infinity, x1 = -Infinity, y1 = -Infinity;

  const expand = (el) => {
    const b = safeGetBBox(el);
    if (!b) return;
    x0 = Math.min(x0, b.x);
    y0 = Math.min(y0, b.y);
    x1 = Math.max(x1, b.x + b.w);
    y1 = Math.max(y1, b.y + b.h);
  };

  if (latestScene.basePreviewPathData) expand(basePreviewPath);
  else {
    expand(letterEl);
    expand(nameOffPath);
  }
  if (latestScene.nameShape) expand(nameFillPath);
  else expand(nameEl);

  const reservedHoop = latestScene.hoopSlot;
  if (reservedHoop) {
    x0 = Math.min(x0, reservedHoop.cx - HOOP_OUTER);
    y0 = Math.min(y0, reservedHoop.cy - HOOP_OUTER);
    x1 = Math.max(x1, reservedHoop.cx + HOOP_OUTER);
    y1 = Math.max(y1, reservedHoop.cy + HOOP_OUTER);
  }

  if (!isFinite(x0)) {
    svgEl.setAttribute("viewBox", "0 0 500 500");
  } else {
    const letterBox = safeGetBBox(letterEl) || { x: (x0 + x1) / 2, y: (y0 + y1) / 2, w: 0, h: 0 };
    const centerX = letterBox.x + letterBox.w / 2;
    const centerY = letterBox.y + letterBox.h / 2;
    const halfW = Math.max(centerX - x0, x1 - centerX) + PREVIEW_PAD;
    const halfH = Math.max(centerY - y0, y1 - centerY) + PREVIEW_PAD;
    svgEl.setAttribute("viewBox", `${(centerX - halfW).toFixed(1)} ${(centerY - halfH).toFixed(1)} ${(halfW * 2).toFixed(1)} ${(halfH * 2).toFixed(1)}`);
  }

  setIdleState();
}

function currentPreviewHoop() {
  if (!S.hoopOn) return null;
  const cx = parseFloat(hoopOuter.getAttribute("cx"));
  const cy = parseFloat(hoopOuter.getAttribute("cy"));
  if (Number.isFinite(cx) && Number.isFinite(cy)) {
    return { cx, cy: cy + EXPORT_HOOP_Y_CORRECTION, rOuter: HOOP_OUTER, rInner: HOOP_INNER };
  }
  return latestScene.hoopSlot
    ? { ...latestScene.hoopSlot, cy: latestScene.hoopSlot.cy + EXPORT_HOOP_Y_CORRECTION }
    : null;
}

function buildWeldedNameExport(nameShape) {
  if (!nameShape?.pathData) return { pathData: "", bounds: null };

  const sc = NAME_WELD_TRACE_SC;
  const pad = Math.ceil(sc * 2);
  const b = nameShape.bounds;
  const cW = Math.ceil(b.w * sc) + pad * 2;
  const cH = Math.ceil(b.h * sc) + pad * 2;
  const ox = pad - b.x * sc;
  const oy = pad - b.y * sc;
  const canvas = document.createElement("canvas");
  canvas.width = cW;
  canvas.height = cH;
  const ctx = canvas.getContext("2d");
  const path = new Path2D(nameShape.pathData);

  ctx.setTransform(sc, 0, 0, sc, ox, oy);
  ctx.fillStyle = "#000";
  ctx.fill(path);
  ctx.strokeStyle = "#000";
  ctx.lineWidth = 0.5;
  ctx.lineJoin = "round";
  ctx.lineCap = "round";
  ctx.stroke(path);
  ctx.setTransform(1, 0, 0, 1, 0, 0);

  const mask = alphaMaskFromCanvas(ctx, cW, cH);
  const loops = traceMaskToLoops(mask, cW, cH, ox, oy, sc, NAME_WELD_MAX_PTS);
  return { pathData: loopsToLinePathData(loops), bounds: boundsFromLoops(loops) };
}

function buildExportSvg() {
  if (S.name && !latestScene.nameShape) return null;

  const exportHoop = currentPreviewHoop();
  const lb = safeGetBBox(letterEl) || { x: 80, y: 60, w: 340, h: 240 };
  const exactLetter = !letterOutlineFontError
    ? buildLetterShape((S.letter || "A").toUpperCase()[0], lb.x + lb.w / 2, lb.y + lb.h / 2)
    : null;

  let baseBounds = null;
  let baseLoops = [];

  if (exactLetter) {
    const baseGeom = vectorizeExactBaseScene(exactLetter, exportHoop);
    baseBounds = baseGeom.bounds;
    baseLoops = baseGeom.loops;
  } else {
    const baseGeom = vectorizeScene({
      includeLetter: true,
      includeNameOffset: !!latestScene.nameOffsetPathData,
      includeNameFill: false,
      includeHoop: S.hoopOn,
      maxPtsPerLoop: EXPORT_BASE_MAX_PTS,
      nameOffsetDy: EXPORT_NAME_OFFSET_Y_CORRECTION,
      preserveLetterCounters: false,
    }, EXPORT_TRACE_SC, exportHoop);
    baseBounds = baseGeom.bounds;
    baseLoops = baseGeom.loops;
  }

  if (!baseBounds) return null;

  const weldedName = latestScene.nameShape ? buildWeldedNameExport(latestScene.nameShape) : { pathData: "", bounds: null };
  const nameBounds = weldedName.bounds;
  const sharedMinY = Math.min(baseBounds.y, nameBounds ? nameBounds.y : baseBounds.y);
  const dy = EXPORT_PAD - sharedMinY;
  const baseDx = EXPORT_PAD - baseBounds.x;
  const nameDx = nameBounds ? EXPORT_PAD + baseBounds.w + EXPORT_GAP - nameBounds.x : 0;
  const basePath = loopsToLinePathData(translateLoops(baseLoops, baseDx, dy));
  const namePath = weldedName.pathData;

  const width = EXPORT_PAD * 2 + baseBounds.w + (nameBounds ? EXPORT_GAP + nameBounds.w : 0);
  const height = Math.max(
    baseBounds.y + dy + baseBounds.h,
    nameBounds ? nameBounds.y + dy + nameBounds.h : 0
  ) + EXPORT_PAD;

  return `<?xml version="1.0" encoding="UTF-8"?>
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${width.toFixed(2)} ${height.toFixed(2)}" width="${width.toFixed(2)}" height="${height.toFixed(2)}">
  <title>Letter Ornament</title>
  <desc>Left panel: base layer. Right panel: top name layer.</desc>
  <g id="base-layer">
    <path d="${basePath}" fill="none" stroke="#ff0000" stroke-width="1" stroke-linejoin="round"/>
  </g>
  ${namePath ? `<g id="name-layer" transform="translate(${nameDx.toFixed(2)},${dy.toFixed(2)})">
    <path d="${namePath}" fill="none" stroke="#ff0000" stroke-width="1" stroke-linejoin="round"/>
  </g>` : ""}
</svg>`;
}

function safeFileName() {
  const letter = (S.letter || "A").replace(/[^a-z0-9]/gi, "").toUpperCase() || "A";
  const name = (S.name || "name").trim().replace(/[^a-z0-9]+/gi, "-").replace(/^-+|-+$/g, "") || "name";
  return `${letter}-${name}-ornament.svg`;
}

async function downloadSvg() {
  setBusyState();
  try {
    if (!fontsAlreadyReady) {
      await document.fonts.ready;
      fontsAlreadyReady = true;
    }
    await loadNameOutlineFont();
    await loadLetterOutlineFont();
    const svg = buildExportSvg();
    if (!svg) throw new Error("Nothing to export yet.");

    const blob = new Blob([svg], { type: "image/svg+xml" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = safeFileName();
    document.body.appendChild(link);
    link.click();
    link.remove();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
    setIdleState();
  } catch (error) {
    console.error(error);
    setIdleState();
  }
}

function clientToSvg(clientX, clientY) {
  const pt = svgEl.createSVGPoint();
  pt.x = clientX;
  pt.y = clientY;
  return pt.matrixTransform(svgEl.getScreenCTM().inverse());
}

let dragging = false;
let dragStart = null;

hoopDragHandle.addEventListener("mousedown", (event) => {
  if (!S.hoopOn) return;
  event.preventDefault();
  dragging = true;
  const pt = clientToSvg(event.clientX, event.clientY);
  dragStart = { svgX: pt.x, svgY: pt.y, offX: S.hoopDragOff.x, offY: S.hoopDragOff.y };
});

hoopDragHandle.addEventListener("touchstart", (event) => {
  if (!S.hoopOn) return;
  event.preventDefault();
  dragging = true;
  const touch = event.touches[0];
  const pt = clientToSvg(touch.clientX, touch.clientY);
  dragStart = { svgX: pt.x, svgY: pt.y, offX: S.hoopDragOff.x, offY: S.hoopDragOff.y };
}, { passive: false });

function onDragMove(clientX, clientY) {
  if (!dragging || !dragStart) return;
  const pt = clientToSvg(clientX, clientY);
  S.hoopDragOff.x = dragStart.offX + (pt.x - dragStart.svgX);
  S.hoopDragOff.y = dragStart.offY + (pt.y - dragStart.svgY);

  if (latestScene.hoopSlot) {
    const dx = S.hoopDragOff.x - dragStart.offX;
    const dy = S.hoopDragOff.y - dragStart.offY;
    const nx = (latestScene.hoopSlot.cx + dx).toFixed(2);
    const ny = (latestScene.hoopSlot.cy + dy).toFixed(2);
    hoopOuter.setAttribute("cx", nx);
    hoopOuter.setAttribute("cy", ny);
    hoopInner.setAttribute("cx", nx);
    hoopInner.setAttribute("cy", ny);
    hoopDragHandle.setAttribute("cx", nx);
    hoopDragHandle.setAttribute("cy", ny);
  }
}

function onDragEnd() {
  if (!dragging) return;
  dragging = false;
  dragStart = null;
  schedRender(0);
}

window.addEventListener("mousemove", (event) => {
  if (dragging) onDragMove(event.clientX, event.clientY);
});
window.addEventListener("mouseup", onDragEnd);
window.addEventListener("touchmove", (event) => {
  if (!dragging) return;
  event.preventDefault();
  onDragMove(event.touches[0].clientX, event.touches[0].clientY);
}, { passive: false });
window.addEventListener("touchend", onDragEnd);

document.getElementById("letter-input").addEventListener("input", function () {
  let v = this.value.replace(/[^a-zA-Z]/g, "");
  if (v.length > 1) v = v.slice(-1);
  this.value = v.toUpperCase();
  S.letter = v.toUpperCase() || "A";
  schedRender();
});

document.getElementById("name-input").addEventListener("input", function () {
  S.name = this.value;
  schedRender();
});

fontRow.addEventListener("click", (event) => {
  const btn = event.target.closest(".font-btn");
  if (!btn) return;
  S.nameFont = btn.dataset.font || DEFAULT_NAME_FONT;
  applyNameFontUi();
  schedRender(0);
});

function quickUpdateName() {
  const font = outlineFonts[S.nameFont];
  if (!font || !S.name) return;
  const lb = safeGetBBox(letterEl) || { x: 80, y: 60, w: 340, h: 240 };
  const lCX = lb.x + lb.w / 2;
  const lCY = lb.y + lb.h / 2;
  const shape = buildNameShape(S.name, S.nameSize, lCX, lCY + S.posOff);
  if (!shape) return;
  nameFillPath.setAttribute("d", shape.pathData);
  nameFillPath.removeAttribute("display");
  nameEl.setAttribute("display", "none");
  latestScene = { ...latestScene, nameShape: shape };
}

sizeSlider.addEventListener("input", function () {
  S.nameSize = parseInt(this.value, 10);
  updateSliderFill(this);
  quickUpdateName();
  schedRender(350);
});

posSlider.addEventListener("input", function () {
  S.posOff = parseInt(this.value, 10);
  updateSliderFill(this);
  quickUpdateName();
  schedRender(350);
});

document.getElementById("hoop-tog").addEventListener("click", function () {
  S.hoopOn = !S.hoopOn;
  if (!S.hoopOn) S.hoopDragOff = { x: 0, y: 0 };
  this.classList.toggle("on", S.hoopOn);
  this.textContent = S.hoopOn ? "Hanging Hoop On" : "+ Add Hanging Hoop";
  hoopHint.style.display = S.hoopOn ? "block" : "none";
  schedRender(0);
});

exportBtn.addEventListener("click", downloadSvg);

document.fonts.ready.then(() => {
  fontsAlreadyReady = true;
  applyNameFontUi();
  updateSliderFill(sizeSlider);
  updateSliderFill(posSlider);
  schedRender(0);
});
